import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Div100vh from "react-div-100vh";
import { motion } from "framer-motion";
import { useTheme } from "@/b2b/context/ThemeContext";

// import screenConfig from "@/b2b/config/guarantorScreenConfig";

import { headingVariants } from "@/lib/data";

import Header from "@/b2b/components/Header";
import Select from "@/components/common/Input/Select";
import TextField from "@/components/common/Input/TextField";
import { updateFunctionB2B } from "@/lib/helper";
import { set } from "date-fns";
import { ClipLoader } from "react-spinners";
import PrimaryButton from "../components/PrimaryButton";

const GuarantorScreen = ({ theme }) => {
  // const { theme } = useTheme();
  const navigate = useNavigate();
  const [disableNextBtn, setDisableNextBtn] = useState(true);
  const { userIdentifier } = useParams();
  // Reliable partner tag (set by HomeScreen) — theme.name resolves async for
  // DB-driven partners and would put `undefined` in the URL.
  const partner = localStorage.getItem("partnerIdentifier");
  const [selectedOption, setSelectedOption] = useState("student");
  const [loading, setLoading] = useState(false);
  const [guarantorDetails, setGuarantorDetails] = useState({
    name: "",
    phone: "",
    relationship: "",
  });
  const [guarantorPan, setGuarantorPan] = useState("");
  const [panData, setPanData] = useState(null);

  const fetchPanDetails = async (pan) => {
    const token = localStorage.getItem("user_identifier");

    setLoading(true);
    try {
      console.log("Fetching PAN details for:", pan);
      const response = await updateFunctionB2B(
        {
          pan_number: pan,
          first_name:
            guarantorDetails.name.split(" ")?.[0] || guarantorDetails?.name,
          last_name: guarantorDetails.name.split(" ")?.[1] || "",
          alt_phone: guarantorDetails.phone,
          relationship: guarantorDetails.relationship,
        },
        "b2b/onboard/check-eligibility-guarantor",
        "Guarantor PAN",
        "Eligibility Check Screen",
        token,
      );
      console.log("Response:", response);

      setPanData(response);
      setDisableNextBtn(false);
      // Process the data as needed
    } catch (error) {
      console.error("Error fetching PAN details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(panData, "panData");
  }, [panData]);

  const handleNext = async () => {
    const token = localStorage.getItem("user_identifier");
    if (selectedOption === "student") {
      if (panData?.isEligible == true) {
        navigate(`/b/${token}?partner=${partner}&step=work-details`);
      } else {
        navigate(`/b/${token}?partner=${partner}&step=sorry`);
      }
      // navigate("/b/" + token);
    } else {
      await updateFunctionB2B(
        { isStudent: false },
        `b2b/onboard/updateanything`,
        "",
        "",
        token,
      );

      setTimeout(() => {
        navigate(`/b/${userIdentifier}`);
      }, 500);
      return;
    }
  };

  return (
    <Div100vh
      className={`flex flex-col justify-start p-8 sm:p-8 gap-6 ${theme?.backgroundColor} ${theme?.text}`}
    >
      <div className="flex flex-col gap-8">
        <Header />
        <div className="flex flex-col gap-1">
          <motion.h1
            className="reveal-heading"
            initial="hidden"
            animate="visible"
            variants={headingVariants}
          >
            <span
              className={`heading mb-heading-subheading ${theme?.headingColor}`}
            >
              {"Guarantor Details"}
            </span>
          </motion.h1>
        </div>

        <div>
          {/* <Select
            options={[
              // { value: "salaried", label: "Salaried" },
              // { value: "self-employed", label: "Self Employed" },
              { value: "student", label: "Student" },
            ]}
            placeholder="Select Employment Status"
            value={selectedOption}
            onChange={(value) => {
              setSelectedOption(value);
              console.log("Selected Value:", value);
              if (value === "salaried" || value === "self-employed") {
                setDisableNextBtn(false);
              }
              // Handle the change event here
            }}
            className={`border p-4 text-base border-primary-500 bg-white text-black focus:outline-none w-full h-14 rounded-none ${theme?.input}`}
          /> */}

          {selectedOption &&
            (selectedOption === "student" ? (
              <div className=" -mt-4 gap-4 flex flex-col">
                <p className="text-sm text-gray-600">
                  Please enter rent payer (guardian/parent) details.
                </p>
                {/* Add additional input fields for student details here */}
                {/* <TextField
                  value={guarantorDetails.name}
                  label={"Guarantor Name"}
                  onChange={(e) => {
                    console.log("Guarantor Name:", e);
                    setGuarantorDetails({
                      ...guarantorDetails,
                      name: e,
                    });
                  }}
                  placeholder="Enter Guarantor Name"
                  className={`border p-4 text-base border-primary-500 bg-white text-black focus:outline-none w-full h-14 rounded-none ${theme?.input}`}
                /> */}
                <Select
                  options={[
                    { value: "father", label: "Father" },
                    { value: "mother", label: "Mother" },
                    { value: "guardian", label: "Guardian" },
                  ]}
                  placeholder="Select Relationship with Guarantor"
                  onChange={(value) => {
                    setGuarantorDetails({
                      ...guarantorDetails,
                      relationship: value,
                    });
                    console.log("Selected Value:", value);
                    // Handle the change event here
                  }}
                  className={`border p-4 text-base border-primary-500 bg-white text-black focus:outline-none w-full h-14 rounded-none ${theme?.input}`}
                />
                <TextField
                  pattern={"/^d{10}$/"}
                  value={guarantorDetails.phone}
                  inputMode={"number"}
                  type={"number"}
                  label={"Guarantor Phone"}
                  maxLength={10}
                  onChange={(e) => {
                    console.log("Guarantor Phone:", e);
                    setGuarantorDetails({
                      ...guarantorDetails,
                      phone: e,
                    });
                  }}
                  placeholder="Enter Guarantor Phone"
                  className={`border p-4 text-base border-primary-500 bg-white text-black focus:outline-none w-full h-14 rounded-none ${theme?.input}`}
                />

                <div className="flex flex-col gap-2">
                  {loading ? (
                    <div className="w-full flex justify-end gap-2">
                      <ClipLoader color="#1987fb" size={20} />
                      <span className="text-black">Checking PAN</span>
                    </div>
                  ) : (
                    <span className="w-full flex justify-end text-black">
                      {panData?.panData?.data?.name}
                    </span>
                  )}
                  <TextField
                    name={"pan_number"}
                    label={"Guarantor PAN Number"}
                    value={guarantorPan.toUpperCase()}
                    required={true}
                    type={"text"}
                    maxLength={10}
                    inputMode={"text"}
                    onChange={(e) => {
                      setGuarantorPan(e.toUpperCase());
                      console.log("Guarantor PAN:", e.toUpperCase());
                      if (e.length === 10) {
                        fetchPanDetails(e.toUpperCase());
                      } else {
                        setPanData(null);
                      }
                    }}
                  />
                </div>
              </div>
            ) : (
              <div></div>
            ))}
        </div>
      </div>

      <PrimaryButton
        text={"Next"}
        loading={loading}
        handleClick={() => handleNext()}
        disabled={loading || disableNextBtn}
        // className={theme.primary}
      />
    </Div100vh>
  );
};

export default GuarantorScreen;
